import React from "react";
import "./HelpButton.css";
import { Button } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

/**
 * A help button component that displays a help icon and can trigger a popup or menu for instructions and assistance.
 * The button is styled using Material-UI and includes handlers for opening and closing the associated menu.
 * 
 * @component
 * @example
 * import HelpButton from "../../Components/HelpButton/HelpButton";
 * <HelpButton />
 * @returns {React.Fragment} The rendered help button component.
 */
function HelpButton({}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  /**
   * Handles the click event to open or close the help menu.
   * 
   * @param {Event} event - The click event.
   */
  const onClickMenuHandler = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  /**
   * Handles closing the help menu.
   */
  const onCloseMenuHandler = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button id="helpButton" onClick={onCloseMenuHandler}>
        <HelpOutlineIcon
          id="helpButtonIcon"
          size="medium"
          edge="end"
          color="inherit"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          aria-label="header_menu"
          onClick={onClickMenuHandler}
          sx={{marginLeft: "auto"}}
        >
      </HelpOutlineIcon>
      </Button>
    </>
  );
}

export default HelpButton;
